import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CoachingSummaryModel} from '../model/coaching-summary.model';
import {CoachingService} from '../service/coaching.service';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {UserService} from '../../../services/user.service';
import {Subscription} from 'rxjs';
import {EventsService} from '../../../services/events.service';
import {AnalyticsService} from '../../../services/analytics.service';

@Component({
    selector: 'app-my-coaching-comments',
    templateUrl: './coaching-comments.component.html',
    styleUrls: ['./coaching-comments.component.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
    ]
})
export class CoachingCommentsComponent implements OnInit, OnDestroy {

    subscriptions: Subscription[] = [];

    pageData: CoachingSummaryModel = null;
    pageDataValid = false;
    pageDataPromise: Promise<CoachingSummaryModel> = null;

    public level = 'learner';
    public delegateId = 0;

    constructor(
        private router: Router,
        private event: EventsService,
        private analytics: AnalyticsService,
        public userService: UserService,
        private activatedRoute: ActivatedRoute,
        private coachingService: CoachingService
    ) {
        this.level = this.activatedRoute.snapshot.data.level;
        if (this.level === 'manager') {
            this.delegateId = Number(this.activatedRoute.snapshot.paramMap.get('del_id'));
        } else {
            this.delegateId = this.userService.getCurrentUserInfo().id;
        }
        this.subscriptions.push(
            this.event.subscribe('coaching:saveCoachingForm', () => this.pageDataValid = false)
        );
    }

    ngOnInit() {
    }

    ionViewWillEnter() {
        if (this.pageData === null || !this.pageDataValid) {
            if (this.level === 'manager') {
                this.pageDataPromise = this.coachingService.getUserCoachingSummary(this.delegateId);
            } else {
                this.pageDataPromise = this.coachingService.getMyCoachingSummary();
            }
        }
    }

    ionViewDidEnter() {
        if (this.level === 'manager') {
            this.analytics.trackView('Coaching Area');
        } else {
            this.analytics.trackView('My Coaching Area');
        }

        if (this.pageData === null || !this.pageDataValid) {
            this.pageDataPromise.then(data => {
                this.pageData = data;
                this.pageDataValid = true;
            });
        }
    }

    goReport(coachingId: number) {
        if (this.level === 'manager') {
            this.router.navigate(['/coaching/user/' + String(this.delegateId) + '/report/', coachingId]);
        } else {
            this.router.navigate(['/coaching/my/report/', coachingId]);
        }
    }

    onPlusClick() {
        this.router.navigate(['/coaching/my/form/new/']);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(i => i.unsubscribe());
    }
}
